<template>
     <select component_name="BootstrapCombobox" style="width: 100%;">
        <option value="">{{placeholder}}</option>
        <option :value="item[valueField]" :key="item[valueField]" 
        v-for="item in data">{{formatOption != null&&formatOption != undefined ? formatOption(item) :(item[textField] || '--')}}</option>
    </select>
</template>
<script>
/**
 * 组件名称：下拉搜索框
 * 特性：
 *  1、支持v-model双向绑定，可以作为普通表单元素进行操作
 * 	2、暂不支持 multiple 属性,不支持多选模式，包括多选的初始化赋值等等
 */
import $ from 'jquery';
import 'select2/select2';
import 'select2/select2_locale_zh-CN.js';
import 'select2/select2.css';
export default {
    name:"BootstrapCombobox",
    props:{
        value:String,
        textField: {//指定展示字段
            type:String,
            default:"text"
        },
        valueField: {//指定value字段,该字段的值用于传给后台
            type:String,
            default:"value"
        },
        placeholder: {//提示信息
            type:String,
            default:"-请选择-"
        },
        formatOption: {//指定格式化显示option的函数,该函数必须返回一个字符串,用作option的展示,该函数默认入参是当前遍历的数据对象
            type:Function,
            default:null
        },
		enabled:{
			 type:Boolean,
			 default:function(){
			   return true;
			 }
		},
        data:{
            type:Array,
            required:true,
            default:function(){
              return [];
            },
            validator: function (value) {
                return value!=null && value!=undefined;
            }
        }
    },
    data:function(){
        return {
            
        }
    },
    mounted:function(){
        $(this.$el).select2({placeholderOption: "first",allowClear:true}).on('change',(e)=>{
            let selectedValue = $(this.$el).select2("val");
			this.$emit('input',selectedValue);
			this.$emit('change',selectedValue);
        });
        //初始化
		if(this.value){
			this.setSelectedValue();
		}
		if(!this.enabled){
			$(this.$el).select2('disable',true);
		}
		else{
			$(this.$el).select2('enable',true);
		}
    },
    methods:{
        setSelectedValue:function(){
		   if(!this.value){
				$(this.$el).select2('val','');
			}
			else{
				if(this.value !== $(this.$el).select2("val")){
				   $(this.$el).select2('val',this.value);
				}
			}
        }
    },
     watch: {
            value:function(v) {
               this.$nextTick(()=>{
                   this.setSelectedValue();
               });
            },
            data:function(){
                console.log('==============22222222222222',this.data)
                this.$nextTick(()=>{
                    this.setSelectedValue();
                });
            },
			enabled:function(){
				this.$nextTick(()=>{
					if(!this.enabled){
						$(this.$el).select2('disable',true);
					}
					else{
						$(this.$el).select2('enable',true);
					}
				});
			}
    },
    beforeDestroy:function(){
        $(this.$el).select2('destroy');
    }
}
</script>
<style scoped>

</style>
